// Collection of functions/components to help us in rendering Bootstrap Tables

class DieselBootstrapTableFormats {
  /** Format a number with 2 digits precision */
  formatNumber (cell) {
    if (cell) {
      return cell.toFixed(2)
    } else {
      return cell
    }
  }

  formatRelevancyNumber (cell) {
    if (cell) {
      return cell.toFixed(2) + 'x'
    } else {
      return '--'
    }
  }

  formatKM (cell) {
    if (isFinite(cell)) {
      if (cell > 1000000) {
        return (cell / 1000000).toFixed(1) + 'M'
      }
      else if (cell > 10000) {
        return (cell / 1000).toFixed(0) + 'K'
      }
      else {
        return cell.toFixed(0)
      }
    }
    else
    {
      return cell
    }
  }

  trackerFormatKM (cell) {
    if (isFinite(cell)) {
      if (cell > 1000000) {
        return (cell / 1000000).toFixed(1) + 'm'
      }
      else if (cell > 1000) {
        return (cell / 1000).toFixed(1) + 'k'
      }
      else {
        return cell.toFixed(0)
      }
    }
    else
    {
      return cell
    }
  }

  formatPercentage = (value) => {
    if (value && value < 1) {
      return '<1%'
    } else {
      return value ? `${Math.round(value)}%` : '0%'
    }
  }

  renderSocialMeta (data, smtype, meta) {
    if (undefined !== data && data.length) {
      for (var i=0;i<data.length;i++){
        if (data[i].platform_type === smtype){
          if (undefined !== data[i].metrics && data[i].metrics.length){
            for (var j=0;j<data[i].metrics.length;j++){
              if (data[i].metrics[j].metric_type === meta){
                return (data[i].metrics[j].value)
              }
            }
          }
        }
      }
    }
    return '--'
  }
}

export const TableFormats = new DieselBootstrapTableFormats()